/*
    锁仓订单状态 - 供应商
*/
export const supplierLockOrderState = {
    0: '已取消',
    1: '已锁仓',
    2: '待同意',
    3: '超时失效',
    4: '未同意',
    5: '已转为下单'
}

/*
    下单订单状态 - 供应商
*/
export const supplierOrderState = {
    2: '未核销', // 通过锁仓下单
    3: '未核销'  // 直接下单
}

